export default {
  isAuthenticated: state => !!state.access_token,
  authStatus: state => state.status,
  authErrors: state => state.errors,
};
